var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24Video = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "camera",
    d: "M15 10.95L12.893 9 15 7.05v3.9zM11.25 12c0 .414-.336.75-.75.75H3.75c-.414 0-.75-.336-.75-.75V6c0-.413.336-.75.75-.75h6.75c.414 0 .75.337.75.75v6zm4.509-6.64c-.47-.205-1.014-.116-1.388.229l-1.621 1.5v-1.09c0-1.24-1.01-2.25-2.25-2.25H3.75C2.51 3.75 1.5 4.76 1.5 6v6c0 1.242 1.01 2.25 2.25 2.25h6.75c1.24 0 2.25-1.008 2.25-2.25v-1.088l1.62 1.5c.24.223.552.339.87.339.175 0 .351-.036.519-.109.457-.2.741-.626.741-1.113V6.472c0-.486-.284-.913-.741-1.113z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24Video, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_video.1b3c3273.svg";
export { ForwardRef as ReactComponent };